import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const Javascript = () => {
  return (
    <StartInterviewLayout type="javascript" />
  )
}

export default Javascript